import React from 'react'
import Button from '../Button'
import './heroHeader.css'
import carPinIcon from '../../images/car-pin-icon.svg'
import heroHeaderIllustrationM from '../../images/hero-header-illustration-m.svg'
import heroHeaderIllustrationD from '../../images/hero-header-illustration-d.svg'
import { AppModalContext } from "../../components/AppModal/context";
import ContactForm from "../../components/ContactForm";
import { motion } from 'framer-motion';

let easing = [0.1575, 0.85, 0.42, 0.96];

const fadeInAnimation = {
  enter: { y: 0, opacity: 1, transition: { duration: 0.8, ease: easing } },
  exit: { y: 0, opacity: 0, transition: { duration: 0.8, ease: easing } }
}

const slideTopAnimation = {
  enter: { x: 0, y: 0, opacity: 1, transition: { duration: 1.3, ease: easing } },
  exit: { x: 0, y: 50, opacity: 0, transition: { duration: 1.3, ease: easing } }
}

const HeroHeader = () => {
  const { handleModal } = React.useContext(AppModalContext);

  return (
    <motion.section initial="exit" animate="enter" exit="exit" className="section section--light section-hero-header">
      <motion.div variants={fadeInAnimation} className="hero-header-inner container-inner">
        <div className="hero-header-content container-inner">
          <img className="pin-car" alt="A pin icon with a car inside" src={carPinIcon}/>
          <div className="heading">Livrări urbane și ieftine și rapide. Da!</div>
          <div className="py-2"></div>
          <ul className="points">
            <li className="point">De la 1 RON/km <span>(fără TVA)</span></li>
            <li className="point">Livrare urgentă, rapidă sau normală de la 1h la 4h</li>
            <li className="point">0% comision</li>
          </ul>
          <Button onClick={() => handleModal(<ContactForm formType="Înregistrează afacerea ta"/>)} type="secondary">Înregistrează afacerea ta</Button>
        </div>
        <motion.img variants={slideTopAnimation} className="illustration-m w-full" src={heroHeaderIllustrationM}/>
        <motion.img variants={slideTopAnimation} className="illustration-d w-full" src={heroHeaderIllustrationD}/>
      </motion.div>
    </motion.section>
  )
}

export default HeroHeader;